import { FC } from 'react';
import { CatalogMode } from '@edikk-edikk/ui';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';
import { CatalogByServiceItem } from '#advertList/components/catalog-by-service/CatalogByServiceItem';
import catalogByServiceCss from '#srcCssModules/advert/catalog/catalog-by-service.module.scss';
import { useBaseContext } from '#base/hooks/use-base-context';

const CatalogByService: FC = () => {
  const { catalogMode } = useBaseContext();
  const { advertDataListByService } = useAdvertListContext();

  if (catalogMode !== CatalogMode.groupingService) {
    return null;
  }

  const catalogElementList = advertDataListByService.chunkDataList.map((chunk) => (
    <CatalogByServiceItem key={chunk.serviceId} chunk={chunk} />
  ));

  return (
    <div className={catalogByServiceCss.catalogByService}>
      {catalogElementList}
    </div>
  );
};

export { CatalogByService };
